<template>
    <div class="mx-auto" style="max-width: 992px;">
        <v-row align="stretch" wrap>
            <v-col :md="$auth.user.full_admin ? '7' : '12'" cols="12">
                <settingProfileCard></settingProfileCard>
            </v-col>
            <v-col md="5" cols="12" v-if="$auth.user.full_admin">
                <settingLicenseCard></settingLicenseCard>
            </v-col>
        </v-row>
        <v-autocomplete
            :items="search ? searchItems : defaultSearchItems"
            v-model:search="search"
            append-inner-icon="search"
            class="mt-8 mb-n9"
            clearable
            label="جستجو"
            no-data-text="موردی پیدا نشد!"
            variant="solo"
            return-object
            @update:model-value="(val) => $router.push({path: val.path})"
        >
            <template #item="{ item, props }">
                <v-divider v-if="item.raw.type == 'divider'"></v-divider>
                <v-list-subheader v-if="item.raw.type == 'subheader'" :title="item.raw.title"></v-list-subheader>
                <v-list-item v-else v-bind="props" :title="item.raw.title" :lines="item.raw?.subtitle ? 'two' : 'one'" :subtitle="item.raw?.subtitle" :prepend-icon="item.raw.icon"></v-list-item>
            </template>
        </v-autocomplete>
        <div class="bg-white my-9 py-8 rounded ps-16 position-relative" v-for="item in Object.values(items).filter(item => item.items.some(x => x.permission))" style="margin-right: 75px;">
            <div :style="{ backgroundColor: `${item.color}`, boxShadow:`0 0 10px ${item.color}` }" class="setting-icons">
                <v-row align="center" class="ma-0" justify="center" style="width: 100%; height: 100%" wrap>
                    <div class="text-center">
                        <v-icon color="white" size="40">{{ item.icon }}</v-icon>
                        <p class="text-white user-select-none text-meta mb-0 mt-3 font-weight-bold px-3">{{ item.name }}</p>
                    </div>
                </v-row>
            </div>
            <v-row class="px-md-16 ps-sm-16 ps-10 pe-sm-8 pe-5" justify="start" wrap>
                <v-col class="text-center px-lg-8 px-md-3 px-1 py-sm-3 py-1" md="3" sm="4" cols="6" v-for="inner in item.items.filter(inner => inner.permission)">
                    <div :class="item.class" @click="$router.push({path: inner.value })" class="settings-options rounded py-5 cursor-pointer">
                        <v-icon :color="`${item.color}`" size="38">{{inner.icon}}</v-icon>
                        <p class="text-small text-black mt-4 mb-0">{{ inner.name }}</p>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import settingSearchBox from "@/variables/settingSearchBox";
export default {
    title: "تنظيمات",
    validate() {
        return Object.values(settingSearchBox()).some(x => x.items.some(y => y.permission));
    },
    data() {
        return {
            items: settingSearchBox(),
            search: null,
        };
    },
    computed: {
        searchItems() {
            let items = [], i = 0;
            for (const key in this.items) {
                this.items[key].items.forEach((element) => {
                    if (element.permission) {
                        items.push({
                            title: element.name,
                            icon: element.icon,
                            subtitle: element.name,
                            value: i++,
                            path: element.value,
                        });
                        element.items.forEach((element2) => {
                            items.push({
                                title: element2,
                                icon: element.icon,
                                subtitle: element.name,
                                value: i++,
                                path: element.value,
                            });
                        });
                    }
                });
            }
            return items;
        },
        defaultSearchItems() {
            let items = [], i = 0;
            for (const key in this.items) {
                if (this.items[key].items.some(x => x.permission)) {
                    items.push({type: 'subheader', title: this.items[key].name});
                    this.items[key].items.forEach(element => {
                        if (element.permission) {
                            items.push({
                                icon: element.icon,
                                title: element.name,
                                value: i++,
                                path: element.value,
                            });
                        }
                    });
                    if (key != Object.keys(this.items).at(-1))
                        items.push({type: 'divider', inset: true});
                }
            }
            return items;
        },
    },
};
</script>

<style lang="scss" scoped>
.settings-options {
    transition: all 0.5s;
    border: 1px solid transparent;
}
.api-option:hover {
    background: #7267f043 0% 0% no-repeat padding-box;
    border: 1px solid #7367f0;
}
.general-option:hover {
    background: #2876dc32 0% 0% no-repeat padding-box;
    border: 1px solid #2877dc;
}
.account-option:hover {
    background: #ffe8d2 0% 0% no-repeat padding-box;
    border: 1px solid #ff9f43;
}
.ticket-option:hover {
    background: #ffe8d2 0% 0% no-repeat padding-box;
    border: 1px solid #ff9f43;
}
.organization-option:hover {
    background: #f0fffa 0% 0% no-repeat padding-box;
    border: 1px solid #34c38f;
}
.customers-option:hover {
    background: #7267f02d 0% 0% no-repeat padding-box;
    border: 1px solid #7367f0;
}
.notice-option:hover {
    background: #da41672d 0% 0% no-repeat padding-box;
    border: 1px solid #da4167;
}
.knowledgebase-option:hover {
    background: #dff0ff 0% 0% no-repeat padding-box;
    border: 1px solid #0b5498;
}
.setting-icons {
    height: 140px;
    width: 140px;
    right: -75px;
    top: 15px;
    position: absolute;
    border-radius: 10px;
}
</style>
